module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-menu pure-menu-horizontal header"
  }, [_c('h1', {
    staticClass: "pure-menu-heading header__title"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v(_vm._s(_vm.appTitle))])]), _vm._v(" "), _c('ul', {
    staticClass: " pure-menu-list header__menu-links"
  }, [(_vm.user) ? _c('li', {
    staticClass: "pure-menu-item",
    class: {
      'pure-menu-selected': _vm.isCalendarVisible
    }
  }, [_c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "title": "Calendar"
    },
    on: {
      "click": _vm.toggleCalendar
    }
  }, [_c('i', {
    staticClass: "icon-calendar"
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pure-menu-item"
  }, [(_vm.user) ? _c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "href": "/logout",
      "title": "Logout"
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c3657a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 119
// module chunks = 1